/* =============================================================================
   trazo.js — El trazo: el hover de la página
   Hotel La Gruta · Arequipa · estilos: "TRAZO" en assets/css/site.css

   Al pasar el cursor (o enfocar con teclado) por un botón o enlace se dibuja la
   costura de la rama —hilo, adorno, hilo— de los EXTREMOS HACIA EL CENTRO: los
   hilos crecen desde los bordes, los tallos y las hojas se trazan de afuera
   hacia adentro y el anillo central cierra. Al salir, se recoge. Es el mismo
   adorno de los separadores entre secciones (.bg-costura--rama en index.html).

   Este script solo INYECTA el markup, una vez, al cargar:
       <span class="trazo" aria-hidden="true">
         <i class="trazo-hilo trazo-hilo--izq"></i><svg class="trazo-adorno">…</svg><i class="trazo-hilo trazo-hilo--der"></i>
       </span>
   y marca el elemento con .has-trazo. Todo el movimiento es CSS (transiciones
   de transform y stroke-dashoffset): no hay JS durante el hover, ni listeners.
   El texto accesible del enlace no cambia (el trazo es aria-hidden y sin texto).

   LA REGLA — todo botón rectangular lleva el trazo, sin tener que listarlo:
   cualquier <a>/<button> con una caja visible (fondo o borde en los cuatro
   lados), esquinas casi rectas (radio ≤ 6px) y texto (≥ 3 letras) lo recibe
   solo. Un botón nuevo con ese aspecto ya lo tiene. Quedan fuera, a propósito:
     · los redondos y en píldora (radio mayor): la línea recta chocaría con la
       curva — .cbtn, .rooms-info-cta, el WhatsApp flotante, las flechas;
     · los de solo ícono o símbolo (→, ✕), que no tienen texto sobre el que
       dibujar;
     · el marco inferior móvil (.frame-bottom), que ya tiene su propio gesto;
     · lo que lleve data-sin-trazo.
   Los ENLACES de texto (sin caja) no se detectan: se listan en SEL.
   Para ajustar uno, usar --trazo-bottom / --trazo-color / --trazo-w en site.css.
   ============================================================================= */
(function () {
  'use strict';

  /* APAGADO (2026-10-30, pedido del usuario): ya no se quiere la línea botánica
     en el hover. No inyecta nada: el hover es ahora un filete de 1 px solo con
     CSS (sección «FILETE» de assets/css/rediseno.css). Para volver al trazo de
     rama, poner TRAZO_ACTIVO = true (y regenerar con `npm run generar:idiomas`). */
  var TRAZO_ACTIVO = false;
  if (!TRAZO_ACTIVO) return;

  // Enlaces de texto (sin caja) y el header. Los botones rectangulares no hace
  // falta listarlos: los recoge la regla de arriba.
  var SEL = [
    '.hdr-nav a', '.hdr-util-link', '.hdr-lang-btn', '.bar-book',
    '.rc-more', '.itin-link', '.home-map-directions', '.gal-filtro',
    '.rooms-selector-tab', '.rv-card', '.cl-link', '.cl-hab',
    '.menu-contact a', '.ft-col a:not(.ft-logo):not(.ft-contact)', '.ft-legal a', '.faq-q'
  ].join(',');
  var RADIO_MAX = 6;       // px: más redondo que esto ya no es un botón rectangular
  var CARAS = ['Top', 'Right', 'Bottom', 'Left'];

  var NS = 'http://www.w3.org/2000/svg';

  /* Mismos trazos que el separador de la rama (viewBox 132×36, horizonte en
     y = 17.5). [d, retardo, duración]. Los tallos nacen en el centro y acaban
     en el extremo: con dashoffset de -1 a 0 se dibujan del extremo hacia el
     centro. Las hojas, de la más externa a la más interna; el anillo, al final. */
  var TRAZOS = [
    ['M63.4 17.5 C52 20.0 40 15.0 26 16.7 S7 18.5 0 17.5', 0, 0.55],
    ['M68.6 17.5 C80 20.0 92 15.0 106 16.7 S125 18.5 132 17.5', 0, 0.55],
    ['M19 18.4 Q14.82 18.38 12.95 22.11 Q17.12 22.13 19 18.4', 0.12, 0.3],
    ['M113 18.4 Q114.88 22.13 119.05 22.11 Q117.18 18.38 113 18.4', 0.12, 0.3],
    ['M30 16.6 Q27.73 12.27 22.84 12.21 Q25.11 16.54 30 16.6', 0.17, 0.3],
    ['M102 16.6 Q106.89 16.54 109.16 12.21 Q104.27 12.27 102 16.6', 0.17, 0.3],
    ['M42 18.4 Q36.4 18.55 33.73 23.47 Q39.33 23.32 42 18.4', 0.22, 0.3],
    ['M90 18.4 Q92.67 23.32 98.27 23.47 Q95.6 18.55 90 18.4', 0.22, 0.3],
    ['M54 16.6 Q50.93 11.08 44.62 10.85 Q47.69 16.37 54 16.6', 0.27, 0.3],
    ['M78 16.6 Q84.31 16.37 87.38 10.85 Q81.07 11.08 78 16.6', 0.27, 0.3],
    ['M66 17.5 m-2.6 0 a2.6 2.6 0 1 0 5.2 0 a2.6 2.6 0 1 0 -5.2 0', 0.4, 0.25]
  ];

  function plantilla() {
    var raiz = document.createElement('span');
    raiz.className = 'trazo';
    raiz.setAttribute('aria-hidden', 'true');

    var izq = document.createElement('i');
    izq.className = 'trazo-hilo trazo-hilo--izq';
    var der = document.createElement('i');
    der.className = 'trazo-hilo trazo-hilo--der';

    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'trazo-adorno');
    svg.setAttribute('viewBox', '0 0 132 36');
    svg.setAttribute('focusable', 'false');
    TRAZOS.forEach(function (t) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('pathLength', '1');
      p.setAttribute('d', t[0]);
      p.setAttribute('style', '--d:' + t[1] + 's;--t:' + t[2] + 's');
      svg.appendChild(p);
    });

    raiz.appendChild(izq); raiz.appendChild(svg); raiz.appendChild(der);
    return raiz;
  }

  /* i18n.js reescribe el contenido de todo elemento con data-i18n /
     data-i18n-html en cada cambio de idioma, y se llevaría el trazo por
     delante. Por eso el texto traducible se pasa a un <span> interior y el
     trazo queda como hermano suyo, fuera del alcance de i18n. */
  function aislarTexto(el) {
    ['data-i18n', 'data-i18n-html'].forEach(function (attr) {
      if (!el.hasAttribute(attr)) return;
      var span = document.createElement('span');
      span.setAttribute(attr, el.getAttribute(attr));
      while (el.firstChild) span.appendChild(el.firstChild);
      el.removeAttribute(attr);
      el.appendChild(span);
    });
  }

  /* ¿Es un botón rectangular con texto? Solo lee estilos calculados (no
     necesita layout, así que sirve también en las páginas ocultas). */
  function esBotonRectangular(el) {
    if (el.hasAttribute('data-sin-trazo') || el.closest('.frame-bottom, [data-sin-trazo]')) return false;
    if ((el.textContent || '').replace(/[^A-Za-zÀ-ÿ]/g, '').length < 3) return false;
    var cs = getComputedStyle(el);
    var radios = ['TopLeft', 'TopRight', 'BottomRight', 'BottomLeft'].map(function (c) {
      return cs['border' + c + 'Radius'].split(' ').every(function (v) { return parseFloat(v) <= RADIO_MAX && v.indexOf('%') === -1; });
    });
    if (radios.indexOf(false) !== -1) return false;
    var fondo = cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent';
    var borde = CARAS.every(function (c) { return parseFloat(cs['border' + c + 'Width']) > 0 && cs['border' + c + 'Style'] !== 'none'; });
    return fondo || borde;
  }

  function montar() {
    var base = plantilla();
    var objetivos = [].slice.call(document.querySelectorAll(SEL));
    document.querySelectorAll('a, button').forEach(function (el) {
      if (!esBotonRectangular(el)) return;
      el.classList.add('trazo-boton');                       // adorno compacto en CSS
      if (objetivos.indexOf(el) === -1) objetivos.push(el);
    });
    objetivos.forEach(function (el) {
      if (el.classList.contains('has-trazo') || el.querySelector('.faq-q-label')) return;
      aislarTexto(el);
      // La pregunta ocupa la fila; el subrayado solo mide su texto.
      if (el.classList.contains('faq-q')) {
        var etiqueta = document.createElement('span');
        etiqueta.className = 'faq-q-label';
        while (el.firstChild) etiqueta.appendChild(el.firstChild);
        el.appendChild(etiqueta);
        el = etiqueta;
      }
      el.classList.add('has-trazo');
      el.appendChild(base.cloneNode(true));
    });
  }

  window.Trazo = { esBotonRectangular: esBotonRectangular };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montar);
  else montar();
})();
